var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPptx64 = function SvgPptx64(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 2048 2048"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1719 544q9 11 9 23v1321q0 14-9 23t-23 9H384q-14 0-23-9t-9-23v-416H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21h152V160q0-14 9-23t23-9h905q7 0 14 2t20 7m-11 407h361l-361-361m384 393h-384q-14 0-23-9t-9-23V160H384v448h536q30 0 51 21t21 51v720q0 30-21 51t-51 21H384v416h1312M474 1274v-165h87q39 0 72-11 32-12 55-33 22-21 35-49 12-29 12-64 0-69-43-107-43-39-126-39H385v468m169-396q87 0 87 78 0 39-23 60t-67 21h-77V878m838-174q60 0 113 23 52 22 91 61t62 92q22 52 22 112h-288m-256-151q38-34 87-53 49-20 105-20v288h288q0 60-22 113-23 52-62 91t-91 62q-53 22-113 22-56 0-105-19-49-20-87-54z",
    className: "pptx_64_svg__OfficeIconColors_HighContrast"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M384 1904q-16 0-16-16V160q0-16 16-16h905q7 0 12 5l406 406q5 5 5 12v1321q0 16-16 16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#797774",
    d: "M1719 544q9 11 9 23v1321q0 14-9 23t-23 9H384q-14 0-23-9t-9-23V160q0-14 9-23t23-9h905q14 0 23 9m384 439h-384q-14 0-23-9t-9-23V160H384v1728h1312M1312 544h361l-361-361z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ED6C47",
    d: "M1312 704q60 0 113 23 52 22 91 61t62 92q22 52 22 112h-288m224 64q0 60-22 113-23 52-62 91t-91 62q-53 22-113 22-56 0-105-19-49-20-87-54v-215z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F6B",
    d: "M1056 841q38-34 87-53 49-20 105-20v288h-192z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.498,
    d: "M1312 704q60 0 113 23 52 22 91 61t62 92q22 52 22 112h-288z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C43E1C",
    d: "M920 608q30 0 51 21t21 51v720q0 30-21 51t-51 21H200q-30 0-51-21t-21-51V680q0-30 21-51t51-21z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M566 806q83 0 126 39 43 38 43 107 0 35-12 64-13 28-35 49-23 21-55 33-33 11-72 11h-87v165h-89V806m89 231h77q44 0 67-21t23-60q0-78-87-78h-80z"
  })));
};
export default SvgPptx64;